export var AnomalyEventType;
(function (AnomalyEventType) {
    AnomalyEventType["New"] = "new";
    AnomalyEventType["Related"] = "related";
    AnomalyEventType["UnrelatedQueries"] = "unrelated_queries";
    AnomalyEventType["Repeats"] = "repeats";
})(AnomalyEventType || (AnomalyEventType = {}));
//# sourceMappingURL=anomalies.js.map